import * as React from 'react';
import { useSelector } from 'react-redux';

import { isRentDailySelector } from 'shared/selectors/isRentDaily';

import { useApplicationContext } from '../../containers/ApplicationContext';
import { sendUXSEvent } from '../../utils/uxs';

export function useCardUxfeedbackCampaign() {
  const { config } = useApplicationContext();
  const isDailyrent = useSelector(isRentDailySelector);

  const campanyName = config.get<string>('uxfeedback.card.desktopCampanyName') || 'AudMonCardDesktop';
  const sendEventTimeout = config.get<number>('uxfeedback.card.sendEventTimeout') || 2_000;

  React.useEffect(() => {
    if (isDailyrent) {
      return;
    }

    setTimeout(() => {
      sendUXSEvent(campanyName);
    }, sendEventTimeout);
  }, [campanyName, sendEventTimeout, isDailyrent]);
}
